import { render, staticRenderFns } from "./competitionBroadcastScreenOption.vue?vue&type=template&id=edc78356&scoped=true"
import script from "./competitionBroadcastScreenOption.vue?vue&type=script&lang=ts"
export * from "./competitionBroadcastScreenOption.vue?vue&type=script&lang=ts"
import style0 from "./competitionBroadcastScreenOption.vue?vue&type=style&index=0&id=edc78356&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc78356",
  null
  
)

export default component.exports